import React, { useEffect } from 'react';
import { message, notification } from 'antd';
import { setMessageApi } from '../utils/messageHandler';
import { setNotificationApi } from '../utils/notificationHandler';

const AppWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [messageApi, messageContextHolder] = message.useMessage();
  const [notificationApi, notificationContextHolder] = notification.useNotification();

  useEffect(() => {
    setMessageApi(messageApi);
    setNotificationApi(notificationApi)
  }, [messageApi,notificationApi]);

  return (
    <>
        {messageContextHolder}
        {notificationContextHolder}
        {children}
    </>
  );
};

export default AppWrapper;